import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TabBar } from './TabBar';
import { useAuth } from '../../contexts/AuthContext';
import { useChatStore } from '../../store/chatStore';
import { useEffect, useCallback, useRef } from 'react';
import { InfoSidebar } from './InfoSidebar';
import { useBibleStore } from '../../store/bibleStore';

export default function Layout() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { 
    loadChats,
    chats = []
  } = useChatStore();
  const hasInitialized = useRef(false);

  const isChatPage = location.pathname.startsWith('/chat/');
  const isHomePage = location.pathname === '/';
  const isBiblePage = location.pathname.startsWith('/bible');
  const chatId = isChatPage ? location.pathname.split('/')[2] : null;

  const initializeData = useCallback(async () => {
    if (!user || hasInitialized.current) {
      return;
    }
    hasInitialized.current = true;
    await loadChats();
    await useBibleStore.getState().syncReadingPosition();
  }, [user, loadChats]);

  useEffect(() => {
    initializeData();
  }, [initializeData]);

  const { 
    selectedVerse,
    selectedVerseText,
    isInfoSidebarOpen,
    setInfoSidebarOpen 
  } = useBibleStore();

  return (
    <div className={`min-h-screen flex bg-[#ffffff] ${
      isHomePage ? "bg-cover bg-center bg-no-repeat bg-top" : ""
    }`}>
      <Sidebar />
      <div 
        className={`
          flex-1 
          transition-all 
          duration-300 
          ${isInfoSidebarOpen ? 'md:mr-[320px]' : 'mr-0'}
          pb-16 md:pb-0
        `}
      >
        <main className={!isBiblePage ? "pt-16" : ""}>
          <Outlet />
        </main>
      </div>
      <InfoSidebar
        isOpen={isInfoSidebarOpen}
        onClose={() => setInfoSidebarOpen(false)}
        verse={selectedVerse}
        verseText={selectedVerseText}
        threadId={isChatPage && Array.isArray(chats) ? chats.find(c => c.id === chatId)?.thread_id : undefined}
        chatId={chatId || undefined}
      />
      <TabBar />
    </div>
  );
}